/**
 * UloTMatterBridge Style01 - UIoT Matter bridge status
 */
import type { TraitControlProps } from './types'

export function UloTMatterBridgeStyle01({ state }: TraitControlProps) {
  const connected = (state?.connected ?? state?.status ?? state?.online) as boolean | string | undefined
  const isConnected = connected === true || connected === 'connected' || String(connected).toLowerCase() === 'true'

  return (
    <div className="smart-home-automation-field">
      <label>UloTMatterBridge</label>
      <div className="smart-home-automation-command-row">
        <span className={`material-symbols-outlined ${isConnected ? 'text-green-400' : 'text-slate-400'}`}>
          hub
        </span>
        <span className="trait-bridge-style01__value">{isConnected ? 'Connected' : 'Disconnected'}</span>
      </div>
    </div>
  )
}
